import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import * as actions from '../action';
import * as c from '../constant';

function PermissionContent({
  handleAddModal,
  handleRemove,
  handleEdit,
  permissionId,
  showPermission,
  permissionInfo,
  permissions,
}) {
  useEffect(() => {
    if (_.isEmpty(permissionId)) return;
    showPermission(permissionId);
  }, []);
  useEffect(() => {
    if (_.isEmpty(permissionId)) return;
    showPermission(permissionId);
  }, [permissionId]);
  return (
    <div className="container-fluid card-section-content">
      <div className="row bg-white pr-2 py-2 mb-2">
        <div className="col-12 d-flex ">
          {Acl(permissions, ['VIEW PERMISSION']) && (
            <button
              type="button"
              onClick={handleAddModal}
              className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-round font-weight-bold px-4 ml-auto"
            >
              Add Permission &nbsp;&nbsp;
              <i className="fas fa-plus" />
            </button>
          )}
        </div>
      </div>
      {!_.isEmpty(permissionInfo) ? (
        <React.Fragment>
          <div className="card">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <div className="col-8">
                  <h3 className="">
                    {' '}
                    {_.get(permissionInfo, 'attributes.name') || '--'}
                  </h3>
                </div>
                <div className="col-4 d-flex">
                  <div className="ml-auto">
                    {Acl(permissions, ['UPDATE PERMISSION']) && (
                      <button
                        type="button"
                        className="btn-blank"
                        onClick={handleEdit(permissionInfo)}
                      >
                        <i className="far fa-edit icon-edit" />
                      </button>
                    )}
                    {Acl(permissions, ['DELETE PERMISSION']) && (
                      <button
                        type="button"
                        className="btn-blank"
                        onClick={handleRemove(permissionInfo)}
                      >
                        <i className="far fa-trash-alt icon-delete" />
                      </button>
                    )}
                  </div>
                </div>
              </div>
              <hr />
              <div className="mt-1">
                <div className="row d-flex justify-content-center">
                  <div className="col-12">
                    <div className="form-wrapper mb-3">
                      <div className="full-group border-bottom">
                        <div className="form-row">
                          <div className="form-input-group col-12 border-right">
                            <label className="full-label mb-0">
                              Permission Name:
                            </label>
                            <span className="full-input">
                              {_.get(permissionInfo, 'attributes.name') || '--'}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      ) : (
        <div className="d-flex align-items-center justitfy-content-center h-100">
          <div className="text-center mx-auto py-4">
            <img
              src={emptyStateImage}
              className="img-responsive image-wrapper mb-4 mt-3"
              alt="Empty State"
            />
            <p className="emp-title mb-0"> No Item Found </p>
          </div>
        </div>
      )}
    </div>
  );
}

PermissionContent.propTypes = {
  handleAddModal: PropTypes.instanceOf(Function).isRequired,
  handleRemove: PropTypes.instanceOf(Function).isRequired,
  handleEdit: PropTypes.instanceOf(Function).isRequired,

  showPermission: PropTypes.instanceOf(Function).isRequired,
  permissionInfo: PropTypes.instanceOf(Object).isRequired,
  permissionId: PropTypes.string.isRequired,
  permissions: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  permissionInfo: _.get(api, `${c.GET_SINGLE_SETTING}.item`) || {},
  permissionId: _.get(match, 'params.permissionId') || '',
  permissions: getJson('permissions'),
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(PermissionContent);
